import { Textarea } from "components/Form/Textarea";
import styled from "styled-components";

export const CustomTextarea = styled(Textarea)`
  resize: vertical;
  height: 150px;
`;
